import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { getUsePrimaryUrlParams } from "../../utils/utils";
import { ISchema } from "clients/LaForgeClient/validation-types/SchemaDefinition";

export const updateCheckProcessedWebhook = (axios: IAxiosInstance) => {
  return async ({
    checkProcessedWebhook,
    userType,
    usePrimary,
    isTestWebhookType,
  }: ISchema["#/definitions/IUpdateCheckProcessedWebhookArgs"]) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/IUpdateCheckProcessedWebhookResponse"]
    >(`/api/updateCheckProcessedWebhook${getUsePrimaryUrlParams(usePrimary)}`, {
      check_processed_webhook: checkProcessedWebhook,
      user_type: userType,
      is_test_webhook_type: isTestWebhookType,
    });

    const { data: responseData } = response;
    if (!responseData.success) {
      throw new Error(`Something went wrong`);
    }
    return responseData;
  };
};
